export const avatarSizeData= [
    {
        class: 'img-90 rounded-circle',
        image: 'avtar/4.jpg'
    },
    {
        class: 'img-80 rounded-circle',
        image: 'avtar/7.jpg'
    },
    {
        class: 'img-70 rounded-circle',
        image: 'avtar/11.jpg'
    }
]

export const avatarStatusData = [
    {
        class: 'img-90 rounded-circle',
        image: 'avtar/16.jpg',
        status: 'status-dnd'
    },
    {
        class: 'img-80 rounded-circle',
        image: 'avtar/7.jpg',
        status: 'status-offline'
    },
    {
        class: 'img-70 rounded-circle',
        image: 'avtar/3.jpg',
        status: 'status-online'
    }
]

export const avatarShapeData = [
    {
        class: 'img-90 b-r-30',
        image: 'avtar/16.jpg'
    },
    {
        class: 'img-80 b-r-35',
        image: 'avtar/3.jpg'
    },
    {
        class: 'img-70 rounded-circle',
        image: 'avtar/11.jpg'
    }
]

export const avatarRatioData = [
    {
        class: 'b-r-8 img-90',
        image: 'avtar/4.jpg'
    },
    {
        class: 'b-r-8 img-80',
        image: 'user/1.jpg'
    },
    {
        class: 'b-r-8 img-70',
        image: 'avtar/16.jpg'
    },
    {
        class: 'b-r-8 img-50',
        image: 'avtar/7.jpg'
    }
]